import {
	Breakpoints,
	BreakpointWrapper,
	Container,
	ContainerGutter,
	ContainerPadding,
	Text,
	TextTag,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { Checkmark } from '@volkswagen-onehub/icons-core';
import React from 'react';
import styled from 'styled-components';
import {
	Equipamiento,
	Oferta,
} from '../../services/ofertas-service/models/ofertas';

export const OfertaCardEquipment = ({
	oferta,
	numberOfOfertas,
}: {
	oferta: Oferta;
	numberOfOfertas: number;
	className: string;
}): React.ReactElement => {
	const ModelEquipmentTextContainer = styled.div`
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-padding-end: 30px !important;

		& > span {
			white-space: nowrap;
		}
	`;

	const calculateNumberOfEquipments = (): number => {
		if (numberOfOfertas > 1) {
			return 3;
		}

		return 4;
	};

	const numberOfEquipments = calculateNumberOfEquipments();

	return (
		<Container
			data-testid="model-equipment-list"
			padding={{ top: ContainerPadding.static200 }}
			wrap={'always'}
			stretchContent
		>
			{oferta &&
				oferta.configuracion.equipamientos?.serie
					.slice(0, numberOfEquipments)
					.map((equipment: Equipamiento, index: number) => {
						return (
							<Container
								data-testid="model-equipment"
								key={index}
								wrap={'never'}
								gutter={ContainerGutter.static200}
							>
								<Text>
									<Checkmark variant="small" />
								</Text>

								<BreakpointWrapper
									min={Breakpoints.default}
									max={Breakpoints.b1920}
								>
									<ModelEquipmentTextContainer className="model-equipment-text-container">
										<Text
											tag={TextTag.span}
											appearance={TokenTextAppearance.copy100}
										>
											{equipment.equipamiento.titulo}
										</Text>
									</ModelEquipmentTextContainer>
								</BreakpointWrapper>
								<BreakpointWrapper min={Breakpoints.b1920}>
									<ModelEquipmentTextContainer className="model-equipment-text-container">
										<Text
											tag={TextTag.span}
											appearance={TokenTextAppearance.copy200}
										>
											{equipment.equipamiento.titulo}
										</Text>
									</ModelEquipmentTextContainer>
								</BreakpointWrapper>
							</Container>
						);
					})}
		</Container>
	);
};
